var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ib-dialog',{attrs:{"visible":_vm.visible,"width":"550px","empty-header":""},on:{"close":function($event){return _vm.$emit('close')}}},[_c('ai-product-requests',{on:{"close":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }